import DataTableController from './data_table_controller';


class AdminDataTableController extends DataTableController {
  load_all_btn_template() {
    return  '<div class="load-more-btn" onclick="data_table_controller.load_all();">'+
              `<span class="common-text-bold">Показать всё</span>`+
            '</div>';
  }

  table_footer_render(api) {
    super.table_footer_render(api);
    const info = api.page.info();
    const currentEndValue = info.end;
    const maxValue = info.recordsTotal;
    if (!this.state_flags.is_there_btn_all && currentEndValue !== maxValue) {
      const footer = $('.table-footer-wrapper');
      footer.append(this.load_all_btn_template());
      this.state_flags.is_there_btn_all = true;
    }
  };

  load_all() {
    const maxPageSize = 10000;
    this.datatable_obj.page.loadMore(maxPageSize);
  }
}

export default AdminDataTableController;
